import { useVisibleSubItems } from '@/hooks/use-visible-sub-items';
import SecondarySidebarLayout from './secondary-sidebar-layout';

export default function TrainingLayout() {
	return <SecondarySidebarLayout title='Training' items={useVisibleSubItems('/training')} />;
}
